@if (messageSent) {
  <div>
    <h3>
      THANK YOU FOR YOUR MESSAGE!
    </h3>
    We will respond to you as soon as possible.
  </div>
}
@if (!messageSent) {
  <form [formGroup]="contactUsInput">
    <div>
      <mat-form-field appearance="outline" style="width: 100%; max-width: 350px;">
        <mat-label>Your Name</mat-label>
        <input
          matInput
          id="name"
          formControlName="name"
          placeholder="Your Name"
          required
          />
          @if (contactUsInput.get('name').hasError('required')) {
            <mat-error
              >
              Your Name is required
            </mat-error>
          }
          @if (contactUsInput.get('name').hasError('maxlength')) {
            <mat-error
              >
              Your Name must be 100 characters or less
            </mat-error>
          }
        </mat-form-field>
      </div>
      <div>
        <mat-form-field appearance="outline" style="width: 100%; max-width: 350px;">
          <mat-label>Email Address</mat-label>
          <input
            matInput
            id="emailAddress"
            formControlName="emailAddress"
            placeholder="Email Address"
            required
            autocomplete="off"
            type="email"
            />
            @if (contactUsInput.get('emailAddress').hasError('required')) {
              <mat-error
                >
                Email Address is required
              </mat-error>
            }
            @if (contactUsInput.get('emailAddress').hasError('email')) {
              <mat-error
                >
                Email Address is not valid
              </mat-error>
            }
          </mat-form-field>
        </div>
        <div>
          <mat-form-field appearance="outline" style="width: 100%; max-width: 350px;">
            <mat-label>Reason for Contact</mat-label>
            <mat-select
              required
              id="contactReason"
              name="contactReason"
              formControlName="contactReason"
              >
              <mat-option value=""> -- Select One -- </mat-option>
              <mat-option value="Homeowner Registration">Homeowner Registration</mat-option>
              <mat-option value="Contractor Registration">Contractor Registration</mat-option>
              <mat-option value="Document Approvals">Document Approvals</mat-option>
              <mat-option value="Contractor Directory">Contractor Directory</mat-option>
              <mat-option value="Contractor Yard Signs">Contractor Yard Signs</mat-option>
              <mat-option value="FEMA Education">FEMA Education</mat-option>
              <mat-option value="Building Officials">Building Officials</mat-option>
              <mat-option value="Press & Media">Press & Media</mat-option>
              <mat-option value="General & Other">General & Other</mat-option>
            </mat-select>
            @if (contactUsInput.get('contactReason').hasError('required')) {
              <mat-error>
                Reason for Contact is required
              </mat-error>
            }
          </mat-form-field>
        </div>
        <div>
          <mat-form-field appearance="outline" style="width: 100%; max-width: 350px;">
            <mat-label>Message</mat-label>
            <textarea
              matInput
              #message
              required
              id="message"
              formControlName="message"
              placeholder="Message"
              >
            </textarea>
            @if (contactUsInput.get('message').hasError('required')) {
              <mat-error
                >
                Message is required
              </mat-error>
            }
            @if (contactUsInput.get('message').hasError('maxlength')) {
              <mat-error
                >
                Message must be 2000 characters or less
              </mat-error>
            }
            <mat-hint align="end">{{message.value.length}} / 2000</mat-hint>
          </mat-form-field>
        </div>
        <div>
          <button
            mat-raised-button
            class="next-ste"
            id="send-email"
            color="primary"
            [disabled]="contactUsInput.pristine || contactUsInput.invalid"
            type="submit"
            (click)="onSave()"
            >
            Send Message
          </button>
        </div>
        @if (formAutoSave) {
          <div style="margin-top: 12px;">
            <mat-progress-bar
              mode="indeterminate"
              style="width: 300px;"
            ></mat-progress-bar>
          </div>
        }
        @if (sendError) {
          <div style="color: #ad2c23;">Error saving your data: <br>{{sendError}}<br><br> Please call us if error persists.</div>
        }
      </form>
    }
